export const ASSETS =
  "https://customer-assets-rejwkqb3.emergentagent.net/job_615163c5-8268-453b-8991-b01bf4cdd80f/artifacts";

export const LOGO = {
  icon: "https://customer-assets-rejwkqb3.emergentagent.net/job_ecorexs-services/artifacts/21b88af4eca155cc_485AEFF1-6414-47C2-B10A-7BD140F580F8.png",
  wordmark: "/wordmark.png",
  emblem: `${ASSETS}/92f13f609dce68e1_glowing_emerald_hexagonal_tech_emblem.png`,
  emblemGlass: `${ASSETS}/293618c068a8c8bb_glowing_emerald_glass_tech_emblem.png`,
};

export const money = (n) =>
  new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(Number(n || 0));

export const FREQ_LABEL = {
  weekly: "Weekly",
  biweekly: "Biweekly (every 2 weeks)",
  monthly: "Monthly",
  yearly: "Yearly",
};
